import { AVAILABLE_PLAYBACK_SPEEDS } from '@core';
import type { AvailablePlaybackSpeed } from '@data';
import { ToggleButtonWithValue, Text, Stack, Box, u } from '@ui';
import { useTranslate } from '@i18n';

interface PlaybackSpeedButtonGroupProps {
    onUpdate: (angle: AvailablePlaybackSpeed) => void;
    selectedPlaybackSpeed: AvailablePlaybackSpeed;
}

export const PlaybackSpeedButtonGroup = ({ onUpdate, selectedPlaybackSpeed }: PlaybackSpeedButtonGroupProps) => {
    const t = useTranslate();
    return (
        <Stack>
            <Text mt={u(1)} pb={u(1)} variant="label">
                {t('user_settings.playback_speed')}
            </Text>
            <Box display="flex" gap={u(3)}>
                {AVAILABLE_PLAYBACK_SPEEDS.map((speed) => (
                    <ToggleButtonWithValue
                        key={speed}
                        value={speed}
                        isActive={speed === selectedPlaybackSpeed}
                        onSelect={onUpdate}
                        variant="radio"
                        typographyVariant="h3"
                        fillWidth
                    >
                        {`${speed}x`}
                    </ToggleButtonWithValue>
                ))}
            </Box>
        </Stack>
    );
};
